export { default } from "./select-preview";
